import { configSubObject } from "../lib/annotations";
import { ConversationOptions } from "./conversation";
import { DiagnosisOptions } from "./diagnosis";
import { FontEndFeatureFlags } from "./frontend";
import { BackofficeConfig } from "./backoffice";
import { ThemeSettings } from "./theme";
import { ClinicGeneralOptions } from "./clinic";
import {PathsOptions} from "./paths";
import {LLMOptions} from "./llmOptions";

export class KahunConfigurationRoot {
  @configSubObject({
    displayName: "Conversation Options",
    description: "options that control the Patient1st chat",
  })
  conversation: ConversationOptions;

  @configSubObject({
    displayName: "LLM Options",
    description: "Configuration options for the LLM (when use-llm enabled)",
  })
  llmOptions?: LLMOptions;

  @configSubObject({
    displayName: "Paths Options (preloader)",
    description: "options that control the paths constructed in preloader",
  })
  pathsOptions: PathsOptions;

  @configSubObject({
    displayName: "Client Feature Flags",
    description: "options that control the front end",
  })
  fe: FontEndFeatureFlags;

  @configSubObject({
    displayName: "Theme",
    description: "options that control the chat theming",
  })
  theme: ThemeSettings;

  @configSubObject({
    displayName: "Backoffice",
    description:
      "options that are sensitive and should be used only within the server",
  })
  backoffice: BackofficeConfig;

  @configSubObject({
    displayName: "Clinic",
    description: "general options for clinic configuration",
  })
  clinic: ClinicGeneralOptions;

  @configSubObject({
    displayName: "Agent Diagnosis",
    description: "options that control the diagnosis run by the agent",
  })
  agentDD: DiagnosisOptions;
}



